export default __webpack_public_path__ + "static/media/27A.18369de8.JPG";